// extracted by mini-css-extract-plugin
module.exports = {"root":"Jumbotron-module--root--3KwMb","wrapper":"Jumbotron-module--wrapper--2GhAM","text":"Jumbotron-module--text--1IZf_"};